import React from 'react';

import { Box, Typography } from '@mui/material';

import type { IrrAidaNameProperties } from './IrrAidaLogo.types';

const FONT_FAMILY =
  '"JetBrains Mono", "Fira Code", "Source Code Pro", monospace';

const VARIANT_STYLES = {
  small: {
    fontSize: { xs: '0.875rem', md: '1rem' },
    fontWeight: 600,
  },
  default: {
    fontSize: { xs: '1.25rem', md: '1.5rem' },
    fontWeight: 600,
  },
  large: {
    fontSize: { xs: '1.5rem', md: '1.75rem' },
    fontWeight: 600,
  },
} as const;

/**
 * Компонент для единообразного отображения названия IRR(aida)
 * с подсветкой "ai" вторичным цветом.
 * Используется как имя аналитика в отчётах.
 */
export const IrrAidaName: React.FC<IrrAidaNameProperties> = ({
  variant = 'default',
  highlightAi = true,
  sx,
  dataTest = 'irr_aida_name',
}) => {
  const variantStyle = VARIANT_STYLES[variant];

  return (
    <Typography
      component='span'
      sx={{
        fontFamily: FONT_FAMILY,
        letterSpacing: 0,
        color: 'primary.main',
        ...variantStyle,
        ...sx,
      }}
      data-testid={dataTest}
    >
      IRR(
      {highlightAi ? (
        <Box
          component='span'
          sx={{
            color: 'secondary.main',
            fontWeight: 700,
          }}
        >
          ai
        </Box>
      ) : (
        'ai'
      )}
      da)
    </Typography>
  );
};

